var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5C15.591 18.5 15.2387 18.3523 14.9432 18.0568C14.6477 17.7613 14.5 17.409 14.5 17V7C14.5 6.591 14.6477 6.23875 14.9432 5.94325C15.2387 5.64775 15.591 5.5 16 5.5H16.75C17.159 5.5 17.5113 5.64775 17.8068 5.94325C18.1023 6.23875 18.25 6.591 18.25 7V17C18.25 17.409 18.1023 17.7613 17.8068 18.0568C17.5113 18.3523 17.159 18.5 16.75 18.5H16ZM8.25 18.5C7.841 18.5 7.48875 18.3523 7.19325 18.0568C6.89775 17.7613 6.75 17.409 6.75 17V7C6.75 6.591 6.89775 6.23875 7.19325 5.94325C7.48875 5.64775 7.841 5.5 8.25 5.5H9C9.409 5.5 9.76125 5.64775 10.0567 5.94325C10.3522 6.23875 10.5 6.591 10.5 7V17C10.5 17.409 10.3522 17.7613 10.0567 18.0568C9.76125 18.3523 9.409 18.5 9 18.5H8.25Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPause);
export default __webpack_public_path__ + "static/media/ic-pause.c13a68dbe75c4fb55ae5dec8c69f131e.svg";
export { ForwardRef as ReactComponent };